import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';

@Injectable({
  providedIn: 'root'
})
export class NoticeManagementService {
  //基础平台微服务api
  prefix: string = environment.seekerWebAPI;

  constructor(
    private http: SwHttpClientService,) { }

  //#region notice 通知公告接口
  /**
   * 分页查询
   * @param param
   * @returns {Observable<any>}
   */
  queryPageList(param) {
    const url = this.prefix + 'notice/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 新增
   * @param param
   * @returns {Observable<any>}
   */
  save(param) {
    const url = this.prefix + 'notice/save';
    return this.http.Post(url, param);
  }

  /**
   * 修改
   * @param param
   * @returns {Observable<any>}
   */
  updateById(param) {
    const url = this.prefix + 'notice/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 删除
   * @param param
   * @returns {Observable<any>}
   */
  deleteBatch(param) {
    const url = this.prefix + 'notice/deleteBatch';
    return this.http.Post(url, param);
  }
  
  /**
   * 查看
   * @param param
   * @returns {Observable<any>}
   */
  queryById(param) {
    const url = this.prefix + 'notice/queryById';
    return this.http.Post(url, param);
  }
  

  //#endregion
}
